import React, { Component } from 'react';
import loading from './loading.svg';

class Callback extends Component {
  render() {
    const style = {
      position: 'absolute',
      display: 'flex',
      justifyContent: 'center',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: '#fff',
    };
    const verticalCenter = {
      margin: 0,
      position: 'absolute',
      top: '50%'
    };

    // If there is an app parm, flag it
    /*
    const params = new URLSearchParams(this.props.location.search);
    let signupApp = params.get("app");
    if (signupApp != null) {
      localStorage.setItem('app_parm', signupApp);
    }
    */

    return (
      <div style={style}>
        <div style={verticalCenter}>
          <img src={loading} height='100' width = '100' alt="loading"/>
        </div>
      </div>
    );
  }
}

export default Callback;